var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHacker = function SvgHacker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.542 76.025c4.057-1.836 9.097-1.836 13.154 0m-17.007-6.086c5.137 4.023 5.137 10.545 0 14.569-5.137 4.023-13.466 4.023-18.603 0-5.137-4.024-5.137-10.546 0-14.57 5.137-4.022 13.466-4.022 18.603 0Zm39.463 0c5.137 4.023 5.137 10.545 0 14.569-5.137 4.023-13.466 4.023-18.603 0-5.137-4.024-5.137-10.546 0-14.57 5.137-4.022 13.466-4.022 18.603 0ZM28.714 40.747C15.866 42.067 8.27 45.065 8.27 47.982c0 4.276 18.683 7.743 41.729 7.743s41.73-3.467 41.73-7.743c0-2.51-6.697-5.406-16.676-6.82M28.854 40.24l8.519-25.635 8.47 5.987s5.948-2.493 9.317-3.95c4.767-2.063 11.72-4.167 11.72-4.167l3.991 13.882 3.99 13.883",
    stroke: "#000",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgHacker;